import { TranslationFunction } from '../../services/localisationContext';
import { getHoffmanEnvironment } from '../../services/windowService';

const { FLAG_NEW_COUNTRIES_ENABLED } = getHoffmanEnvironment();

// ANOTHER_COUNTRY is disabled since Workstation Configurator is available only for GSA for now.
// https://hoffmann-group-digital.atlassian.net/browse/WSC-2317
// To enable search for 'WSC-2317' comments and enable them

// WSC-2317:
// export const ANOTHER_COUNTRY = 'ANOTHER';
export const countries = FLAG_NEW_COUNTRIES_ENABLED
  ? [
      'AT',
      'CH',
      'DE',
      'NL',
      'BE',
      'FR',
      'ES',
      'PT',
      'GB',
      'CZ',
      'DK',
      'IT',
      'SK',
      'HU',
      'RO',
      'SI',
      'PL',
      'LU',
      'LI',
    ].sort()
  : [
      'AT',
      'CH',
      'DE',
      'NL',
      'BE',
      'FR',
      'ES',
      'PT',
      'GB',
      'CZ',
      'DK',
      'IT',
      'SK',
      'HU',
      'RO',
      'SI',
      'LI',
    ].sort();

export type SupportedCountries = typeof countries[number];
export const testCountry = 'NB';

export const supportedCountries = (t: TranslationFunction): Record<SupportedCountries, string> => {
  const map = {};
  countries.forEach((country) => {
    map[country] = t(country);
  });
  return map as Record<SupportedCountries, string>;
};
